module.exports = {
    academy: () => require("./images/academy.png"),
    arrow_line: () => require("./images/arrowline.png"),
    bg_circle: () => require("./images/bgcircle.png"),
    coin: () => require("./images/coin.png"),
    coin2: () => require("./images/coin2.png"),
    moneybag: () => require("./images/moneybag.png"),
    prdt: () => require("./images/prdt.png"),
    tradeX: () => require("./images/tradex.png"),
    one: () => require("./images/1.png"),
    two: () => require("./images/2.png"),
    three: () => require("./images/3.png"),
    four: () => require("./images/4.png"),};
